import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-field-agent-confirm-modal',
  templateUrl: './field-agent-confirm-modal.component.html',
  styleUrls: ['./field-agent-confirm-modal.component.scss'],
  standalone: false
})
export class FieldAgentConfirmModalComponent {
  constructor(
    public dialogRef: MatDialogRef<FieldAgentConfirmModalComponent>
  ) {}

  submit(value) {
    this.dialogRef.close(value);
  }
}